/*
 * @Author: shfang
 * @Date: 2022-11-10 09:31:13
 * @LastEditors: shfang
 * @LastEditTime: 2022-11-14 09:58:03
 * @Description: file content
 * @FilePath: \identityserver4web\src\main.js
 */
import Vue from "vue";
import App from "./App.vue";
import { router, farmeOut } from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "./assets/css/element.scss";
import "./assets/css/Common.css";
import { get } from "./utils/axios";
import authService from "./assets/coustomJs/auth";
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
import axios from "axios";
import GoEasy from "goeasy";

var xhr = new XMLHttpRequest();
xhr.open("get", "config.json", false);
xhr.send();

/* import config from './utils/config.js' */
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.prototype.$authServices = authService;
Vue.prototype.$config = JSON.parse(xhr.responseText); // config.getConfig()
Vue.prototype.$api = require("./utils/api").default;
Vue.prototype.goeasy = GoEasy.getInstance({
  host: "hangzhou.goeasy.io", //若是新加坡区域：singapore.goeasy.io
  appkey: "PC-178f604593bf423b9c17b6916a9fcee4",
  modules: ["pubsub"], //根据需要，传入‘pubsub’或'im’，或数组方式同时传入
});

Vue.use(ElementUI);
Vue.use(ViewUI);
new Vue({
  router,
  store,
  ViewUI,
  render: (h) => h(App),
}).$mount("#app");
// Start If 解决学位英语从从老电大调过来
let sqCode = geturlparam("sqCode");
let platform = geturlparam("platform");
if (sqCode) {
  sessionStorage.setItem("sqCode", sqCode);
  sessionStorage.setItem("platform", platform);
}

function geturlparam(name) {
  let url = window.location.href;
  let p = url.split("?")[1];
  let params = new URLSearchParams(p);
  return params.get(name);
}
// End If
router.beforeEach(async (to, from, next) => {
  //to.path 目标路由
  //next 必须有否则程序不会继续执行
  console.log(farmeOut);
  console.log(farmeOut.some((x) => x.name == to.name));
  if (farmeOut.some((x) => x.name == to.name)) {
    store.commit("updateFarmeIn", false);
  } else {
    store.commit("updateFarmeIn", true);
  }
  var res = await authService.getAuthState();
  console.log(store);
  store.commit("updateAuthState", res);
  if (res == false) {
    await authService.login();
  } else {
    next();
  }
});
